import { combineReducers } from 'redux';

import { userAddressReducer } from './userAddress';
import { userBankrollReducer } from './userBankroll';
import { userProcessesReducer } from './userProcesses';
import { userReferralReducer } from './userReferral';

export const currentUserDataReducer = combineReducers({
  userAddress: userAddressReducer,
  userReferral: userReferralReducer,
  userProcesses: userProcessesReducer,
  userBankroll: userBankrollReducer,
});
